














import Vue from 'vue'
import { mdiCreditCardOutline } from '@mdi/js'
import { IPaymentMethod, IShipping } from '@/models'
import { createNamespacedHelpers } from 'vuex'
import { STORE_MODULES, ACTIONS_ORDER } from '@/enums'

const { mapActions } = createNamespacedHelpers(STORE_MODULES.ORDER)

export default Vue.extend({
    name: 'BtnSubmit',

    props: {
        orderCode: { type: String, required: true },
        paymentMethod: Object as () => IPaymentMethod,
        shipping: Object as () => IShipping,
    },

    data: () => ({
        isRequestInProgress: false,
    }),

    computed: {
        isMobile(): boolean {
            return this.$vuetify.breakpoint.xsOnly
        },

        icon(): string {
            return mdiCreditCardOutline
        },
    },

    methods: {
        ...mapActions({ createPayment: ACTIONS_ORDER.CREATE_PAYMENT }),

        async submit() {
            this.isRequestInProgress = true

            try {
                await this.createPayment(
                    await this.createPayment({
                        orderCode: this.orderCode,
                        shippingId: this.shipping.shippingID,
                        paymentMethod: this.paymentMethod,
                    })
                )
            } catch (error) {}

            this.isRequestInProgress = false
        },
    },
})
